function daysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

function today() {
    var date = new Date();
    date.setHours(0, 0, 0, 0);
    return {
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate()
    };
}

/**
 * This class is used in conjunction with the Expression Language only. Do not call directly.
 */
export default {
    daysInMonth: daysInMonth,
    daysInLocalDate: function daysInLocalDate(ld) {
        return daysInMonth(ld.year, ld.month);
    },
    toMidnightDate: function toMidnightDate(localDate) {
        if (localDate) {
            return new Date(localDate.year, localDate.month, localDate.day);
        }
        return null;
    },
    today: today
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-util-js/LocalDateUtil.js
// module id = 114
// module chunks = 0